<form [formGroup]="propertyDetailsForm">
  <mat-card class="report-card mb-4" *ngIf="property">
    <mat-card-content>
      <div class="row">
        <div class="col-10">
          <h5 class="mb-2 prop-address">{{ property.Address ? property.Address : property.reportName }}</h5>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-12 col-md-4 pr-0">
          <img
            class="img-fluid mx-auto report-image"
            [src]="
              property?.imgUrl
                ? property.imgUrl
                : listingImageBaseUrl + '?ListingId=' + (property.ListingId || 'null') + '&imageName=1&height=219'
            "
          />
        </div>
        <div class="col-12 col-md-8 mt-m-2">
          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field>
                <mat-label>Property Type</mat-label>
                <mat-select formControlName="subType">
                  <mat-option *ngFor="let type of propertyTypes" [value]="type">{{ type }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-6 col-md-3 prop-items">
              <mat-form-field class="small-form-field">
                <mat-label>Beds</mat-label>
                <input matInput type="number" formControlName="beds" [attr.disabled]="!isDisabled" />
              </mat-form-field>
            </div>
            <div class="col-6 col-md-3 prop-items">
              <mat-form-field class="small-form-field">
                <mat-label>Baths</mat-label>
                <input matInput type="number" formControlName="baths" [attr.disabled]="!isDisabled" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 prop-items">
              <mat-form-field class="small-form-field">
                <mat-label>Year Built</mat-label>
                <input
                  matInput
                  type="number"
                  min="1800"
                  [max]="currentYear"
                  formControlName="yearBuilt"
                  [attr.disabled]="!isDisabled"
                />
              </mat-form-field>
            </div>
            <div class="col-6 col-md-3 prop-items">
              <mat-form-field class="small-form-field">
                <mat-label>Parking</mat-label>
                <input matInput type="number" formControlName="parking" [attr.disabled]="!isDisabled" />
              </mat-form-field>
            </div>
            <div class="col-md-3 col-6 prop-items">
              <mat-form-field class="small-form-field">
                <mat-label>Stories</mat-label>
                <input matInput type="number" formControlName="stories" [attr.disabled]="!isDisabled" />
              </mat-form-field>
            </div>
            <div class="col-md-3 col-6 prop-items">
              <mat-form-field class="small-form-field">
                <mat-label>Lot Size</mat-label>
                <input currencyMask matInput type="text" formControlName="lotSize" [attr.disabled]="!isDisabled" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-6 prop-items">
              <mat-form-field class="small-form-field">
                <mat-label>Living Area</mat-label>
                <input
                  currencyMask
                  matInput
                  type="text"
                  formControlName="livingArea"
                  [attr.disabled]="!isDisabled"
                  required
                />
              </mat-form-field>
            </div>
            <div class="col-md-3 col-6 prop-items">
              <mat-form-field class="small-form-field">
                <mat-label>Months Back</mat-label>
                <input currencyMask matInput type="text" formControlName="monthsBack" [attr.disabled]="!isDisabled" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
